import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campPlNew: FaireAdCampaignEntity = {
  token: "camp_pl_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_pennyline",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 1000,
  startedRunningAt: "2026-02-12",
  segmentMetrics: {
    numCustomersAcquired: 192,
    salesDollars: 111625,
    totalAdsSpendDollars: 10040,
    cpaDollars: 52.29,
    bestEstimateSalesDollars: 116266,
    bestEstimateRoas: 11.58,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-25T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
